import { render, staticRenderFns } from "./accidentManagement.vue?vue&type=template&id=349fe486&scoped=true"
import script from "./accidentManagement.vue?vue&type=script&lang=js"
export * from "./accidentManagement.vue?vue&type=script&lang=js"
import style0 from "./accidentManagement.vue?vue&type=style&index=0&id=349fe486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349fe486",
  null
  
)

export default component.exports